import { SETUP_DISMISSED_SESSION_KEY } from '@/features/admin/platform-setup/constants'

// Le stockage peut être indisponible (navigation privée) : l'assistant se rouvrira, sans gravité.

/** L'assistant ne se rouvre plus tout seul pendant la session (« Plus tard » ou terminé). */
export function markSetupDismissed() {
  try {
    sessionStorage.setItem(SETUP_DISMISSED_SESSION_KEY, 'true')
  } catch {
    /* stockage indisponible */
  }
}

export function isSetupDismissed() {
  try {
    return sessionStorage.getItem(SETUP_DISMISSED_SESSION_KEY) === 'true'
  } catch {
    return false
  }
}

const NAV_AUTO_OPEN_KEY = 'platformSetupNavAutoOpen'

/** Demande l'ouverture, une seule fois, de la liste « Mise en route » du menu (fin de l'assistant). */
export function markNavAutoOpen() {
  try {
    sessionStorage.setItem(NAV_AUTO_OPEN_KEY, 'true')
  } catch {
    /* stockage indisponible */
  }
}

/** Vrai une seule fois après markNavAutoOpen. */
export function consumeNavAutoOpen() {
  try {
    const pending = sessionStorage.getItem(NAV_AUTO_OPEN_KEY) === 'true'
    sessionStorage.removeItem(NAV_AUTO_OPEN_KEY)
    return pending
  } catch {
    return false
  }
}
